module.exports = __webpack_public_path__ + "img/hero.c83d1269.png";